import axios from "axios";
import { Auth } from "aws-amplify";

const baseURL = process.env.REACT_APP_API_HOST;

const instance = axios.create({
  baseURL,
  timeout: 30000,
});

function handlerError(error) {
  console.log("ERROR:", error);
  return Promise.reject(error);
}

async function addToken(config) {
  const session = await Auth.currentSession();
  const { jwtToken } = await session.getAccessToken();
  config.headers["Authorization"] = `Bearer ${jwtToken}`;
  return config;
}

export const fns = {
  addToken,
  handlerError,
};

instance.interceptors.request.use(fns.addToken, fns.handlerError);

export default instance;
